<template>
    <div class="">
        <v-row>
            <v-col class="">
                <div class="top-three-wrap">
                    <v-row class="custom-align">
                        <v-col
                            cols="4"
                            sm="3"
                            md="2"
                            offset-md="3"
                            align-self="end"
                            justify="end"
                            class="top-three-section-end top-three-section"
                            >
                            <div class="top-three-content">
                                <div class="avatar-wrap top-second">
                                    <v-img
                                        :src="`https://assets.beeverso.org/avatar/${second.avatar.name}/${second.avatar.value}`"
                                        alt="Avatar"
                                        :max-height="$vuetify.breakpoint.xs ? '56' : '72'"
                                        :max-width="$vuetify.breakpoint.xs ? '56' : '72'"
                                        class="transition-all mx-auto"
                                    >
                                    </v-img>
                                    <div class="avatar-position">2</div>
                                </div>
                                <p class="top-name mb-0">{{ setName(second) }}</p>
                                <div class="top-points">
                                    <span class="mr-1">{{ second.points }}</span>
                                    <v-img
                                        :src="require('@/assets/img/icons/xp-coin.png')"
                                        height="32"
                                        width="32"
                                    ></v-img>
                                </div>
                            </div>
                        </v-col>
                        <v-col
                            cols="4"
                            sm="3"
                            md="2">
                            <div class="top-three-content">
                                <div class="avatar-wrap top-first">
                                    <v-img
                                        :src="`https://assets.beeverso.org/avatar/${first.avatar.name}/${first.avatar.value}`"
                                        alt="Avatar"
                                        :max-height="$vuetify.breakpoint.xs ? '72' : '100'"
                                        :max-width="$vuetify.breakpoint.xs ? '72' : '100'"
                                        class="transition-all mx-auto"
                                    >
                                    </v-img>
                                    <div class="avatar-position">1</div>
                                    <div class="avatar-crown">
                                        <v-img
                                            :src="require('@/assets/img/icons/icon-crown.svg')"
                                            height="24"
                                            width="24"
                                            contain>
                                        </v-img>
                                    </div>
                                </div>
                                <p class="top-name mb-0">{{ setName(first) }}</p>
                                <div class="top-points">
                                    <span class="mr-1">{{ first.points }}</span>
                                    <v-img
                                        :src="require('@/assets/img/icons/xp-coin.png')"
                                        height="32"
                                        width="32"
                                    ></v-img>
                                </div>
                            </div>
                        </v-col>
                        <v-col
                            cols="4"
                            sm="3"
                            md="2"
                            class="top-three-section-start top-three-section"
                            align-self="end"
                            justify="start">
                            <div class="top-three-content">
                                <div class="avatar-wrap top-third">
                                    <v-img
                                        :src="`https://assets.beeverso.org/avatar/${third.avatar.name}/${third.avatar.value}`"
                                        alt="Avatar"
                                        :max-height="$vuetify.breakpoint.xs ? '56' : '72'"
                                        :max-width="$vuetify.breakpoint.xs ? '56' : '72'"
                                        class="transition-all mx-auto"
                                    >
                                    </v-img>
                                    <div class="avatar-position">3</div>
                                </div>
                                <p class="top-name mb-0">{{ setName(third) }}</p>
                                <div class="top-points">
                                    <span class="mr-1">{{ third.points }}</span>
                                    <v-img
                                        :src="require('@/assets/img/icons/xp-coin.png')"
                                        height="32"
                                        width="32"
                                    ></v-img>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <!-- <img :src="topImg" alt="" class="podio-img" />
        <div class="position-absolute first-content">
            <div class="position-relative d-flex justify-center align-center flex-column">
                <v-btn class="point-banner position-absolute px-9" color="#dad2f4"
                    ><span>{{ first.points }}</span></v-btn
                >
                <div class="first-avatar">
                    <img
                        :src="`https://assets.beeverso.org/avatar/${first.avatar.name}/${first.avatar.value}`"
                        alt="Avatar"
                        height="150"
                        width="150"
                        class="transition-all mb-10"
                    />
                </div>
                <div class="first-number white--text">1</div>
                <div class="first-name white--text text-capitalize">{{ setName(first) }}</div>
            </div>
        </div>
        <div class="position-absolute second-content">
            <div class="position-relative d-flex justify-center align-center flex-column">
                <v-btn class="point-banner position-absolute px-9" color="#dad2f4"
                    ><span>{{ second.points }}</span></v-btn
                >
                <div class="second-avatar">
                    <img
                        :src="`https://assets.beeverso.org/avatar/${second.avatar.name}/${second.avatar.value}`"
                        alt="Avatar"
                        height="150"
                        width="150"
                        class="transition-all"
                    />
                </div>
                <div class="second-number white--text">2</div>
                <div class="second-name white--text">{{ setName(second) }}</div>
            </div>
        </div>
        <div class="position-absolute third-content">
            <div class="position-relative d-flex justify-center align-center flex-column">
                <v-btn class="point-banner position-absolute px-9" color="#dad2f4"
                    ><span>{{ third.points }}</span></v-btn
                >
                <div class="third-avatar">
                    <img
                        :src="`https://assets.beeverso.org/avatar/${third.avatar.name}/${third.avatar.value}`"
                        alt="Avatar"
                        height="150"
                        width="150"
                        class="transition-all"
                    />
                </div>
                <div class="third-number white--text">3</div>
                <div class="third-name white--text">{{ setName(third) }}</div>
            </div>
        </div> -->
    </div>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        first: { type: Object, default: null },
        second: { type: Object, default: null },
        third: { type: Object, default: null },
    },
    data() {
        return { topImg: require('@/assets/img/illustrations/ranking.svg') }
    },
    methods: {
        setName(data) {
            return `${this.capitalizeText(data.firstName.split(' ')[0])} ${this.capitalizeText(
                data.lastName.split(' ')[0]
            )}`
        },
        capitalizeText(text) {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
        },
    },
}
</script>
<style lang="scss">
.first-content {
    margin-left: -3vh;
}
.second-content {
    transform: rotate(-5deg);
}

.third-content {
    transform: rotate(5deg);
}

.point-banner {
    top: -5vh;
    border-radius: 7px;
    color: #514773;
}

.third-content .point-banner {
    top: 1vh !important;
    right: -4vh;
}

.second-content .point-banner {
    top: 1vh !important;
    left: -4vh;
}

.point-banner span {
    color: #514773;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
    font-size: 18px;
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .podio-img {
        width: 95vh;
        /* max-width: 100vh; */
    }

    .first-content {
        top: 15vh;
        width: 97.5%;
    }
    .first-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .second-content {
        top: 25vh;
        left: 7.5vh;
    }
    .second-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .third-content {
        top: 25vh;
        right: 10vh;
    }
    .third-number {
        font-weight: bolder;
        font-size: 86px;
    }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
    .podio-img {
        width: 110vh;
        /* max-width: 80vh; */
    }

    .first-content {
        top: 20vh;
        width: 97.5%;
    }
    .first-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .second-content {
        top: 40vh;
        left: 12.5vh;
    }
    .second-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .third-content {
        top: 40vh;
        right: 15vh;
    }
    .third-number {
        font-weight: bolder;
        font-size: 86px;
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .podio-img {
        width: 45vw;
        /* max-width: 80vh; */
    }

    .first-content {
        top: 15vh;
        width: 97.5%;
    }
    .first-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .second-content {
        top: 27vh;
        left: 7.5vh;
    }
    .second-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .third-content {
        top: 28vh;
        right: 10vh;
    }
    .third-number {
        font-weight: bolder;
        font-size: 86px;
    }
}

.top-three-wrap{
    background: linear-gradient(270deg, #7764CA 0%, #A295DA 34.22%, #6857B2 71.35%, #514585 100%);
    border-radius: 12px;
    color: #fff;
    padding: 16px 0 8px;
}
.avatar{
    &-wrap{
        position: relative;
        .v-image{
            background: #fff;
            border: 2px solid;
            border-radius: 50%;
            box-shadow: 0px 12px 24px 0px #63450766;
        }
        &.top-first{
            .v-image{
                border-color: #F5BE3D;
            }
            .avatar-position{
                background: #F5BE3D;
            }
        }
        &.top-second{
            .v-image{
                border-color: #6DCDDD;
            }
            .avatar-position{
                background: #6DCDDD;
            }
        }
        &.top-third{
            .v-image{
                border-color: #828DF6;
            }
            .avatar-position{
                background: #828DF6;
            }
        }
    }
    &-position{
        position: absolute;
        bottom: -12px;
        left: 50%;
        background: #7764CA;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        color: #fff;
        font-size: 14px;
        transform: translateX(-50%);
    }
    &-crown{
        position: absolute;
        top: -24px;
        left: 50%;
        transform: translateX(-50%);
        .v-image{
            background: transparent;
        }
    }
}
.avatar-crown .v-image{
    border: 0;
    border-radius: 0;
    // box-shadow: 0px 4px 12px 0px #63450780;

}
.top-name{
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    margin: 16px auto 0;
    max-width: 80px;
    word-break: keep-all;
}
.top-points{
    align-items: center;
    display: inline-flex;
    font-size: 18px;
    font-weight: 600;
}
.top-three-section{
    display: flex;
    flex-direction: column;
}
.top-three-section-end{
    justify-content: end;
    align-items: end;
}
.top-three-section-start{
    justify-content: start;
    align-items: start;
}
.top-three-content{
    text-align: center;
}
.custom-align{
    @media screen and (max-width: 960px) {
        margin: 0 12.5%;
        width: 100%;
    }
    @media screen and (max-width: 600px) {
        margin: 0;
    }
}
</style>
